import turbolinksLoadedObservable from '@newswebsiteapp/shared/observables/turbolinksLoadedObservable'
import nightmodeSubject from './subject'

turbolinksLoadedObservable.subscribe(() => {
  $('[data-switcher-to-night]').click((e) => {
    e.preventDefault()
    nightmodeSubject.next(true)
  })

  $('[data-switcher-to-day]').click((e) => {
    e.preventDefault()
    nightmodeSubject.next(false)
  })
})
